import * as React from 'react';
import { DelopgaveBedoemmelsesFaktor } from '../../models/DelopgaveBedoemmelsesFaktor';
import { ResultatAngivesIEnum } from '../../models/enums/ResultatAngivesIEnum';

export interface HoldnavnOgBedoemmelsesFaktorerFeltProps {
    holdNavn: string;
    bedoemmelsesFaktorer: DelopgaveBedoemmelsesFaktor[];
    resultatAngivesI: ResultatAngivesIEnum;
}

export interface HoldnavnOgBedoemmelsesFaktorerFeltState {
}

export default class HoldnavnOgBedoemmelsesFaktorerFelt extends React.Component<HoldnavnOgBedoemmelsesFaktorerFeltProps, HoldnavnOgBedoemmelsesFaktorerFeltState> {
    constructor(props: HoldnavnOgBedoemmelsesFaktorerFeltProps) {
        super(props);

        this.renderBedoemmelsesFaktorer = this.renderBedoemmelsesFaktorer.bind(this);
    }

    renderBedoemmelsesFaktorer() {
        if (this.props.bedoemmelsesFaktorer.length > 0) {
            return (
                <ul>
                    {this.props.bedoemmelsesFaktorer.map(b => (<li key={b.id}><span>{b.titel}</span></li>))}
                    <li className='samlet-felt'>Samlet</li>
                </ul>
            );
        }
        return <div />;
    }    

    render() {
        const divClass = this.props.bedoemmelsesFaktorer.length > 0 ? 'flere-bedoemmelsesfaktorer' : '';
        const classes = 'column-holdnavn-bedoemmelsesfaktorer ' + divClass;
        return (
            <div className={classes}>
                <h5>{this.props.holdNavn}</h5>
                {this.renderBedoemmelsesFaktorer()}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgaveBedoemmelse/HoldnavnOgBedoemmelsesFaktorerFelt.tsx